export const defaultServiceName = "RaizIQ";
export const defaultAppOrigin = "https://raiziq.com";

export function serviceSlugFromName(value = defaultServiceName) {
  const slug = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "");
  return slug || "app";
}

export function normalizeServiceName(value = defaultServiceName) {
  const name = String(value || "").trim();
  return name || defaultServiceName;
}

export function normalizeOrigin(value, fallback = defaultAppOrigin) {
  const raw = String(value || fallback || "").trim();
  if (!raw) return "";

  try {
    return new URL(raw).origin;
  } catch {
    return fallback && fallback !== value ? normalizeOrigin(fallback, "") : "";
  }
}

export function defaultServiceXHandle(serviceName = defaultServiceName) {
  const compactName = normalizeServiceName(serviceName).replace(/[^A-Za-z0-9_]/g, "");
  return `join${compactName || defaultServiceName}`;
}

export function deriveLiveOrigin(appOrigin) {
  const origin = normalizeOrigin(appOrigin, "");
  if (!origin) return "";

  const url = new URL(origin);
  const host = url.hostname.toLowerCase();
  if (host === "localhost" || host === "127.0.0.1" || host === "0.0.0.0") return "";
  if (host.endsWith(".local") || host.endsWith(".pages.dev")) return "";
  return `${url.protocol}//live.${url.hostname}`;
}

function firstAllowedOrigin(value) {
  return String(value || "")
    .split(",")
    .map((item) => item.trim())
    .find(Boolean);
}

export function readAppConfig(env = {}) {
  const serviceName = normalizeServiceName(env.service_name || env.SERVICE_NAME || defaultServiceName);
  const serviceSlug = serviceSlugFromName(serviceName);
  const explicitAppOrigin = String(env.APP_ORIGIN || "").trim();
  const appOrigin = normalizeOrigin(
    explicitAppOrigin ||
      env.VITE_PUBLIC_SITE_ORIGIN ||
      env.PUBLIC_SITE_ORIGIN ||
      env.SITE_ORIGIN ||
      env.PUBLIC_APP_ORIGIN ||
      firstAllowedOrigin(env.ALLOWED_CLIENT_ORIGINS),
    defaultAppOrigin
  );
  const legacyLiveOrigin = explicitAppOrigin ? "" : env.VITE_LIVE_ORIGIN;
  const liveOrigin = normalizeOrigin(env.LIVE_ORIGIN || legacyLiveOrigin || deriveLiveOrigin(appOrigin), "");
  const fallbackXHandle = defaultServiceXHandle(serviceName);
  const serviceXHandle = String(env.SERVICE_X_HANDLE || fallbackXHandle).replace(/^@/, "").trim() || fallbackXHandle;

  return {
    serviceName,
    serviceSlug,
    appOrigin,
    publicSiteOrigin: appOrigin,
    liveOrigin,
    livePublishUrl: liveOrigin ? `${liveOrigin}/publish/batch` : "",
    liveWorkerName: `${serviceSlug}-live`,
    walletAuthStatement: `Sign in to ${serviceName}.`,
    trustedTypesPolicyName: serviceSlug,
    serviceXHandle,
    serviceXProfileUrl: `https://x.com/${serviceXHandle}`
  };
}
